import * as React from 'react';
import EmailFooterV2 from '../components/FooterV2';

interface InvoiceDetails {
  invoiceNumber: string;
  date: string;
  dueDate: string;
  amount: string;
  status: string;
  items?: Array<{
    description: string;
    quantity: number;
    unitPrice: string;
    total: string;
  }>;
}

interface InvoiceEmailProps {
  name?: string;
  company?: string;
  supportEmail?: string;
  domain?: string;
  invoice?: InvoiceDetails;
  downloadLink?: string;
  paymentLink?: string;
  accountLink?: string;
}

export const InvoiceEmail: React.FC<InvoiceEmailProps> = ({
  name = 'João Silva',
  company = 'Trivium',
  supportEmail = 'suporte@trivium.com.br',
  domain = 'trivium.com.br',
  invoice = {
    invoiceNumber: 'INV-2023-001',
    date: '01/08/2023',
    dueDate: '15/08/2023',
    amount: 'R$ 99,90',
    status: 'Pendente',
    items: [
      {
        description: 'Assinatura Premium - Mensal',
        quantity: 1,
        unitPrice: 'R$ 99,90',
        total: 'R$ 99,90'
      }
    ]
  },
  downloadLink = 'https://trivium.com.br/fatura/INV-2023-001/download',
  paymentLink = 'https://trivium.com.br/fatura/INV-2023-001/pagamento',
  accountLink = 'https://trivium.com.br/minha-conta/faturas',
}) => {
  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <img 
          src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Logo%20Trivium%20Rebranded%20Branco%20150%20dpi-0VfiiO2tOZNdZlvY5A7z3saYZGysgq.png" 
          alt="Trivium"
          style={logoImageStyle}
        />
      </div>
      
      {/* Content */}
      <div style={contentStyle}>
        <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ backgroundColor: '#E7F2FF' }}>
          <tr>
            <td align="center" style={{ padding: '40px 20px' }}>
              <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ maxWidth: '400px' }}>
                {/* Círculo com ícone */}
                <tr>
                  <td align="center" style={{ paddingBottom: '30px' }}>
                    <div style={{ 
                      width: '60px', 
                      height: '60px', 
                      borderRadius: '50%', 
                      backgroundColor: '#1F1746', 
                      display: 'inline-block',
                      textAlign: 'center',
                      lineHeight: '60px'
                    }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
                        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" fill="white"/>
                      </svg>
                    </div>
                  </td>
                </tr>
                
                {/* Título */}
                <tr>
                  <td align="center" style={{ paddingBottom: '15px' }}>
                    <h1 style={{ 
                      margin: '0',
                      fontSize: '28px',
                      color: '#333333',
                      fontWeight: '600'
                    }}>
                      Nova Fatura
                    </h1>
                  </td>
                </tr>
                
                {/* Mensagem */}
                <tr>
                  <td align="center" style={{ paddingBottom: '25px' }}>
                    <p style={{ 
                      margin: '0',
                      fontSize: '16px',
                      color: '#666666'
                    }}>
                      Fatura #{invoice.invoiceNumber}
                    </p>
                  </td>
                </tr>
                
                {/* Badge */}
                <tr>
                  <td align="center">
                    <div style={{ 
                      backgroundColor: invoice.status === 'Pago' ? '#4CAF50' : '#FF9800',
                      borderRadius: '24px',
                      color: '#FFFFFF',
                      fontWeight: '600',
                      fontSize: '15px',
                      padding: '12px 25px',
                      display: 'inline-block'
                    }}>
                      {invoice.status}
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        
        <div style={contentContainerStyle}>
          <h2 style={titleStyle}>Olá, {name}!</h2>
          
          <p style={paragraphStyle}>
            Enviamos este e-mail para informar que uma nova fatura foi gerada para sua conta na {company}.
            Você encontrará abaixo os detalhes da fatura e instruções para pagamento.
          </p>
        </div>
        
        <div style={invoiceCardStyle}>
          <div style={invoiceHeaderStyle}>
            <h3 style={invoiceTitleStyle}>Detalhes da Fatura</h3>
          </div>
          
          <div style={invoiceDetailsStyle}>
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Número da fatura:</div>
                <div style={detailValueStyle}>{invoice.invoiceNumber}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Data de emissão:</div>
                <div style={detailValueStyle}>{invoice.date}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Data de vencimento:</div>
                <div style={detailValueStyle}>{invoice.dueDate}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Valor total:</div>
                <div style={{ ...detailValueStyle, fontWeight: '700', color: brandColor, fontSize: '17px' }}>
                  {invoice.amount}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {invoice.items && invoice.items.length > 0 && (
          <div style={itemsContainerStyle}>
            <h3 style={itemsHeadingStyle}>Itens da Fatura</h3>
            
            <table style={itemsTableStyle}>
              <thead>
                <tr>
                  <th style={tableHeaderStyle}>Descrição</th>
                  <th style={{ ...tableHeaderStyle, width: '60px', textAlign: 'center' }}>Qtd</th>
                  <th style={{ ...tableHeaderStyle, width: '90px', textAlign: 'right' }}>Preço</th>
                  <th style={{ ...tableHeaderStyle, width: '90px', textAlign: 'right' }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {invoice.items.map((item, index) => (
                  <tr key={index}>
                    <td style={tableCellStyle}>{item.description}</td>
                    <td style={{ ...tableCellStyle, textAlign: 'center' }}>{item.quantity}</td>
                    <td style={{ ...tableCellStyle, textAlign: 'right' }}>{item.unitPrice}</td>
                    <td style={{ ...tableCellStyle, textAlign: 'right', fontWeight: '600' }}>{item.total}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={3} style={{ ...tableCellStyle, textAlign: 'right', fontWeight: '600' }}>Total:</td>
                  <td style={{ ...tableCellStyle, textAlign: 'right', fontWeight: '700', color: brandColor }}>{invoice.amount}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
        
        <div style={actionsContainerStyle}>
          <h3 style={actionsTitleStyle}>Opções de Pagamento</h3>
          
          <div style={actionsContentStyle}>
            <p style={actionTextStyle}>
              Para efetuar o pagamento da sua fatura, você pode utilizar o link abaixo ou acessar 
              sua área de cliente para visualizar todas as opções de pagamento disponíveis.
            </p>
            
            <div style={buttonContainerStyle}>
              <a href={paymentLink} style={buttonStyle}>
                Pagar Agora
              </a>
            </div>
            
            <p style={alternativeTextStyle}>ou</p>
            
            <div style={secondaryButtonContainerStyle}>
              <a href={downloadLink} style={secondaryButtonStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px', verticalAlign: 'text-bottom' }}>
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill="#1F1746"/>
                </svg>
                Baixar Fatura
              </a>
            </div>
          </div>
        </div>
        
        <hr style={hrStyle} />
        
        <div style={footerContentStyle}>
          <p style={footerStyle}>
            Se você tiver alguma dúvida sobre esta fatura, entre em contato conosco:
          </p>
          <div style={contactChannelsStyle}>
            <p style={contactChannelStyle}>✉️ {supportEmail}&nbsp;&nbsp;📱 (11) 3181-5940</p>
          </div>
          <p style={footerStyle}>
            Atenciosamente,<br />
            Equipe {company}
          </p>
        </div>
      </div>
      
      {/* Footer */}
      <EmailFooterV2 variant="clean" showContactInfo={true} />
    </div>
  );
};

// Estilos
const brandColor = '#1F1746';
const accentColor = '#3E5FBA';
const backgroundColor = '#F5F7FA';
const textColor = '#333333';
const secondaryTextColor = '#666666';

const containerStyle = {
  fontFamily: "'Satoshi', Arial, sans-serif",
  maxWidth: '600px',
  margin: '0 auto',
  backgroundColor: backgroundColor,
};

const headerStyle = {
  backgroundColor: brandColor,
  padding: '25px',
  textAlign: 'center' as const,
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
};

const logoImageStyle = {
  maxWidth: '180px',
  height: 'auto',
  display: 'block',
  margin: '0 auto',
};

const contentStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '0 0 8px 8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
  padding: '0',
  margin: '0 0 20px 0',
  overflow: 'hidden',
};

const contentContainerStyle = {
  padding: '0 40px',
};

const titleStyle = {
  fontSize: '24px',
  fontWeight: '600',
  color: brandColor,
  marginBottom: '16px',
  padding: '24px 0 0 0',
};

const paragraphStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  color: textColor,
  margin: '16px 0',
};

const invoiceCardStyle = {
  border: '1px solid #E1E4E8',
  borderRadius: '8px',
  overflow: 'hidden',
  margin: '24px 40px',
};

const invoiceHeaderStyle = {
  backgroundColor: brandColor,
  padding: '16px 24px',
};

const invoiceTitleStyle = {
  margin: '0',
  color: '#ffffff',
  fontSize: '18px',
  fontWeight: '600',
};

const invoiceDetailsStyle = {
  padding: '20px 24px',
  backgroundColor: '#ffffff',
};

const detailBlockStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: '16px',
};

const detailIconContainerStyle = {
  width: '24px',
  marginRight: '12px',
  paddingTop: '2px',
};

const detailLabelStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  fontWeight: '500',
  marginBottom: '4px',
};

const detailValueStyle = {
  fontSize: '15px',
  color: textColor,
  fontWeight: '500',
};

const itemsContainerStyle = {
  padding: '0 40px',
  margin: '32px 0',
};

const itemsHeadingStyle = {
  fontSize: '18px',
  fontWeight: '600',
  color: brandColor,
  margin: '0 0 16px 0',
};

const itemsTableStyle = {
  width: '100%',
  borderCollapse: 'collapse' as const,
  fontSize: '14px',
};

const tableHeaderStyle = {
  padding: '10px',
  borderBottom: '2px solid #E1E4E8',
  textAlign: 'left' as const,
  fontWeight: '600',
  color: textColor,
};

const tableCellStyle = {
  padding: '12px 10px',
  borderBottom: '1px solid #E1E4E8',
  color: textColor,
};

const actionsContainerStyle = {
  padding: '24px 40px',
  backgroundColor: '#F8F9FA',
  margin: '24px 40px',
  borderRadius: '8px',
};

const actionsTitleStyle = {
  fontSize: '18px',
  fontWeight: '600',
  color: brandColor,
  margin: '0 0 16px 0',
};

const actionsContentStyle = {
  textAlign: 'center' as const,
};

const actionTextStyle = {
  fontSize: '15px',
  lineHeight: '22px',
  color: textColor,
  margin: '0 0 20px 0',
};

const alternativeTextStyle = {
  margin: '16px 0',
  color: secondaryTextColor,
  fontSize: '14px',
};

const buttonContainerStyle = {
  margin: '24px 0 16px 0',
};

const secondaryButtonContainerStyle = {
  margin: '16px 0 8px 0',
};

const buttonStyle = {
  backgroundColor: '#4CAF50',
  borderRadius: '6px',
  color: '#fff',
  fontSize: '16px',
  fontWeight: '600',
  textDecoration: 'none',
  padding: '12px 32px',
  display: 'inline-block',
  transition: 'background-color 0.3s ease',
};

const secondaryButtonStyle = {
  backgroundColor: '#FFFFFF',
  borderRadius: '6px',
  color: brandColor,
  fontSize: '15px',
  fontWeight: '600',
  textDecoration: 'none',
  padding: '10px 24px',
  display: 'inline-block',
  transition: 'background-color 0.3s ease',
  border: `1px solid ${brandColor}`,
};

const hrStyle = {
  borderColor: '#E1E4E8',
  margin: '32px 40px 24px 40px',
};

const footerContentStyle = {
  padding: '0 40px 32px 40px',
};

const footerStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  margin: '8px 0',
};

const contactChannelsStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  marginBottom: '20px',
  marginTop: '8px',
};

const contactChannelStyle = {
  fontSize: '15px',
  color: textColor,
  margin: '6px 0',
  fontWeight: '500',
};

const emailFooterStyle = {
  backgroundColor: backgroundColor,
  padding: '24px 40px',
  textAlign: 'center' as const,
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
};

const copyrightStyle = {
  fontSize: '13px',
  color: secondaryTextColor,
  margin: '0 0 12px 0',
};

const footerLinksStyle = {
  margin: '8px 0',
};

const footerLinkStyle = {
  color: brandColor,
  textDecoration: 'none',
  fontSize: '13px',
  fontWeight: '500',
};

const footerDividerStyle = {
  color: secondaryTextColor,
  margin: '0 8px',
};

export default InvoiceEmail; 